<header>
  <div class="header-landing" [ngClass]="{'sent': sent}">
    <img src="assets/img/Full.png" width="150px" height="23px" class="landing-logo" [routerLink]="['']">
  </div>
</header>